const appState = (state) => state.assignments;
const data = (state) => state.data.assignments;

export const hasFetchedAssignments = (state) =>
  appState(state).hasFetchedAssignments;
export const isFetchingAssignments = (state) => appState(state).isFetching;
export const isErrored = (state) => appState(state).isErrored;
export const selectedSpace = (state) => appState(state).selectedSpace;
export const assignmentQuery = (state) => appState(state).query;
export const assignments = (state) => data(state).assignments;
export const assignment = (state, assignmentId) =>
  assignments(state).find(
    (a) => a.id === assignmentId || a.objectId === assignmentId
  );
export const submissions = (state, assignmentId) =>
  data(state).submissions[assignmentId] || [];
export const isFetchingSubmissions = (state, assignmentId) =>
  !!(appState(state).submissions[assignmentId] || {}).fetching;
export const fetchSubmissionsErrored = (state, assignmentId) =>
  !!(appState(state).submissions[assignmentId] || {}).errored;
export const hasFetchedSubmissions = (state, assignmentId) =>
  !!(appState(state).submissions[assignmentId] || {}).fetched;
export const totalSubmissions = (state, assignmentId) =>
  (appState(state).submissions[assignmentId] || {}).totalSubmissions;
export const filteringSubmissionsByGroup = (state, assignmentId) =>
  (appState(state).submissions[assignmentId] || {}).byGroup;
